import ApiPage from "@/app/(app)/settings/api/page";

export default function ApiSettingsPage() {
  return <ApiPage />;
}
